import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';
import { ContactFromComponent } from '../contact-from/contact-from.component';

@Component({
  selector: 'app-contact-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./contact-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class ContactListComponent extends BaseListComponent implements OnInit {
  @Input() ref;

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public service: BaseRichService,
    public translator: TranslateService
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entity = 'contact';
    this.form = ContactFromComponent;
    this.searchable = !this.ref;
  }

  getBody() {
    const body = super.getBody();
    if (this.ref) {
      const query = ['account_id', '=', this.ref];
      if (body.query) {
        body.query = [body.query, 'and', query];
      } else {
        body.query = query;
      }
    }
    return body;
  }

  getFormData() {
    return { account_id: this.ref };
  }

}
